import { Card, styled, TabPanel } from '../../../base';

export const CardWrapper = styled(Card)(({ theme }) => ({
    padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
    display: 'flex',
    maxHeight: '340px',
    height: '100%',
}));

export const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
    width: '100%',
    flexGrow: 1,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-track': {
        background: theme.palette.background.paper,
    },
    '&::-webkit-scrollbar-thumb': {
        background: theme.palette.grey[400],
        borderRadius: '3px',
    },
}));
